export const CnasDeclarationAnnuelle = {
    path: '/cnas_declaration_annuelle',
    name: 'cnas_declaration_annuelle',
    component: () => import('@/views/Impression/CnasDeclarationAnnuelle/CnasDeclarationAnnuellePage.vue'),
}